/**
 * Charts live on a mutable AppContext ref, so React cannot observe when one is
 * registered or torn down. Hooks that mirror a chart instance into state subscribe
 * here instead of polling, which is what lets them drop an instance as soon as its
 * widget unmounts — a pane switching to multistrike removes its candle chart, and a
 * retained reference would otherwise point at a destroyed chart forever.
 */
type Listener = () => void

const listeners = new Set<Listener>()

export function subscribeChartRegistry(listener: Listener): () => void {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

export function notifyChartRegistryChange(): void {
    listeners.forEach((listener) => listener())
}
